import { Component } from '@angular/core';
import { EnumScales } from '@library/store/measures/measures.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { ControlPageStore, GraphModes } from '@pages/control-page/control-page-store.service';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-control-page-graph-minmax',
  templateUrl: './control-page-graph-minmax.component.html',
  styleUrls: ['./control-page-graph-minmax.component.scss']
})
export class ControlPageGraphMinmaxComponent {

  private values = [GraphModes.DEFAULT, GraphModes.MINMAX];

  GraphModes = GraphModes;

  supportsScale = (scale: EnumScales) => {
    return [
      EnumScales.MONTH_DAILY,
      EnumScales.YEAR,
    ].includes(scale);
  };

  private display$ = combineLatest({
    scale: this.controlPageStore.scale$,
    card: this.controlPageStore.card$.pipe(isDefined())
  }).pipe(
    map(({scale, card}) => this.cardService.supportGraphModes(card.graphType) && this.supportsScale(scale)),
  );

  vm$ = combineLatest({
    display: this.display$,
    minmax: this.controlPageStore.options$,
    selectedIndex: this.controlPageStore.options$.pipe(
      map(options => this.values.indexOf(options.graphMode)),
    ),
  });

  constructor(
    private controlPageStore: ControlPageStore,
    private cardService: ControlPageCardService,
  ) { }

  async setMinmax(graphMode: GraphModes) {
    this.controlPageStore.setOptions({
      graphMode: graphMode,
    });
  }

}
